<!DOCTYPE html>
<html lang="es">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Tasas</title>
    <style>
        body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
            overflow: hidden;
        }

        .card {
            display: flex;
            flex-direction: column;
            overflow-y: auto;
        }

        .card-header {
            color: black;
            padding: 10px;
            font-size: 1.2em;
        }

        .scrollable-table {
            width: 100%;
            overflow-x: auto;
            border: 1px solid #ccc;
            margin: 10px 0;
        }

        table {
            border-collapse: collapse;
            width: 100%;
        }

        th,
        td {
            border: 1px solid #ccc;
            padding: 12px 16px;
            white-space: nowrap;
        }

        th {
            background-color: #f4f4f4;
            font-weight: 600;
            text-align: left;
            width: 50%;
        }

        td {
            background-color: #fff;
            text-align: center;
        }

        td[contenteditable] {
            background-color: #fff;
            cursor: text;
        }

        td[contenteditable]:focus {
            outline: 2px solid #00abb0;
        }

        .btn-guardar {
            background-color: #00abb0;
            color: white;
            border: none;
            border-radius: 6px;
            padding: 10px 28px;
            font-size: 1em;
            cursor: pointer;
            transition: background-color 0.2s;
        }

        .btn-guardar:hover {
            background-color: #008f93;
        }

        .footer-actions {
            display: flex;
            justify-content: flex-end;
            padding: 12px 16px;
            border-top: 1px solid #ccc;
        }

        .refresh-icon {
            font-size: 20px;
            color: #00abb0;
            cursor: pointer;
            margin-left: 8px;
            transition: transform 0.2s;
        }

        .refresh-icon:hover {
            transform: rotate(360deg);
            color: #00abb0;
        }
    </style>
</head>

<body>
    <div class="card">

        <div class="card-header" style="display: flex; align-items: center; justify-content: space-between;">
            <b>Actualización de Tasas</b>
        </div>

        <div class="scrollable-table">
            <table>
                <tbody>
                    <tr>
                        <th>Plazos</th>
                        <td>
                            <mat-select [(ngModel)]="nuevoRegistro.plazo" style="width: 100%;">
                                <mat-option *ngFor="let plazo of plazosDisponibles" [value]="plazo">
                                    {{ plazo }}
                                </mat-option>
                            </mat-select>
                        </td>
                    </tr>
                    <tr>
                        <th>Tasa Efectiva Anual</th>
                        <td id="cell-tasa" contenteditable="true" (blur)="capturarTasa($event)"></td>
                    </tr>
                    <tr>
                        <th>Seguro</th>
                        <td id="cell-seguro" contenteditable="true" (blur)="capturarSeguro($event)"></td>
                    </tr>
                    <tr>
                        <th>Comisión</th>
                        <td id="cell-comision" contenteditable="true" (blur)="capturarComision($event)"></td>
                    </tr>
                    <tr>
                        <th>Tasa Gasto de Cobranza</th>
                        <td id="cell-cobranza" contenteditable="true" (blur)="capturarCobranza($event)"></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="footer-actions">
            <button class="btn-guardar" (click)="guardarNuevoRegistro()">
                Guardar
            </button>
        </div>

    </div>
</body>

</html>